import React from "react";
import DocumentUpload from "../../../../components/DocumentUpload";
import { renderFields } from "../../UploadDetailsData";
import { UTILITY_FIELDS } from "../../UploadDetailsFields";
import "./index.scss";

const UtilityForm = ({
  isGSTRegistered,
  formData,
  errors,
  handleChange,
  handleBlur,
  utilityFile,
  handleUtilityFileChange,
  existingUtilityFile,
}) => {
  if (isGSTRegistered !== "no") return null;

  return (
    <div className="utility-form-section">
      <p className="utility-note">
        Since GST is not registered, please provide utility bill details as
        address proof.
      </p>
      <div className="form-grid">
        {renderFields(
          UTILITY_FIELDS,
          formData,
          errors,
          handleChange,
          handleBlur,
        )}
      </div>
      <div className="doc-upload-row">
        <DocumentUpload
          label="Utility Bill Document"
          name="utility_file"
          file={utilityFile}
          existingFile={existingUtilityFile || null}
          onChange={(e) => handleUtilityFileChange(e.target.files[0])}
          required
        />
      </div>
    </div>
  );
};

export default UtilityForm;
